import useStore from "../../../lib/itn-ui-kit/data/store";
import BaseRepository from "../../../lib/itn-ui-kit/services/repositories/base-repository";
import DocumentModel from "../../models/document";

export default class DocumentRepository extends BaseRepository {
  static modelClass = DocumentModel;
  modelName = "document";

  async createRecord(data) {
    return await useStore.getState().createRecord(this.modelName, data);
  }

  async upload(params) {
        return await super.upload({
          ...params,
          urlPath:
            DocumentModel.urlPath + '/upload_with_appointments_and_bills/',
        });
  }

}
